// Mounts the commercial property detail view and its responsive state.
import { createApp } from 'vue';

import Filters from '../components/general/filters.vue';
import PropertyContainer from '../components/property/property-container.vue';
import getWindowSize from '../helpers/getWindowSize';

const propertyElement = document.getElementById('property-container');

if (propertyElement) {
    const propertyApp = createApp({
        components: { PropertyContainer },
        template: '<PropertyContainer :window-size="windowSize" />',
        data() {
            return { windowSize: getWindowSize() };
        },
        mounted() {
            window.addEventListener('resize', this.updateWindowSize);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.updateWindowSize);
        },
        methods: {
            updateWindowSize() {
                this.windowSize = getWindowSize();
            },
        },
    });

    propertyApp.config.compilerOptions.whitespace = 'preserve';
    propertyApp.component('filters', Filters);
    propertyApp.mount(propertyElement);
}

const footerElement = document.getElementById('footer-cta');
if (footerElement) {
    const footerApp = createApp({});
    footerApp.config.compilerOptions.whitespace = 'preserve';
    footerApp.component('filters', Filters);
    footerApp.mount(footerElement);
}
